import { api } from "../../utils/api";

export async function getLogs(data) {
  try {
    const response = await api({
      method: 'GET', // Forçar o método GET
      url: 'log', 
      params: data
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}


